import { createContext, useContext } from 'react';

/**
 * MODO QUIOSQUE — as rotas /coletor e /bancada (terminais de chão) montam as
 * MESMAS páginas do WMS, mas fora do Layout (sem sidebar/navbar) e com este
 * contexto ligado. Quem precisa se comportar diferente num terminal (ex.: o
 * crachá vira SÓ-LEITOR, sem campo digitável) pergunta aqui, em vez de
 * receber prop atravessando cinco níveis.
 */
const KioskContext = createContext(false);

export const KioskProvider = ({ children }) => (
    <KioskContext.Provider value={true}>{children}</KioskContext.Provider>
);

export const useKiosk = () => useContext(KioskContext);

export default KioskContext;
